import { render, staticRenderFns } from "./register-task.vue?vue&type=template&id=b8349a0e&lang=pug&"
import script from "./register-task.vue?vue&type=script&lang=ts&"
export * from "./register-task.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports